<template>

    <v-section name="Layout" :expanded="expanded">

        <v-action name="Format">
            <v-menu>
                <v-menu-item
                    title="Fluid"
                    :active="action.format === 'plain'"
                    @click.native="updateFormat('plain')">
                </v-menu-item>
                <v-menu-item
                    title="Centered"
                    :active="action.format === 'html'"
                    @click.native="updateFormat('html')">
                </v-menu-item>
            </v-menu>
        </v-action>

        <v-action name="Background Color">
            <v-input-color size="sm" :model="action.background_color" @input="updateBackgroundColor" />
        </v-action>

    </v-section>

</template>

<script>

import Action from '../actions/Action';
import Section from './Section';

export default {

    components: {
        'v-action': Action,
        'v-section': Section,
    },

    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        action() {
            return this.$store.getters['builder/action'];
        },

    },

    methods: {

        updateFormat(format) {
            let action = this.action;
            this.$set(action, 'format', format);
            this.$store.commit('builder/setAction', action);
            // Update template
            let template = document.getElementById('template');
            template.classList.remove('format-html');
            template.classList.remove('format-plain');
            template.classList.add(`format-${format}`);
        },

        updateBackgroundColor(color) {
            let action = this.action;
            this.$set(action, 'background_color', color);
            this.$store.commit('builder/setAction', action);
            // Update template
            let template = document.getElementById('template');
            template.style.background = color;
        },

    },

}

</script>